import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ThemeService } from "../theme/theme-service.service";
import { PreviousUrlService } from "../services/previous-url.service";

@Component({
    selector: "app-admin-dashboard",
    templateUrl: "./admin-dashboard.component.html",
    styleUrls: ["./admin-dashboard.component.scss"],
    standalone: false
})
export class AdminDashboardComponent implements OnInit {
  public sectionTitle: string = "Admin Dashboard";
  public previousLink: string;
  constructor(
    private router: Router,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private previousUrl: PreviousUrlService
  ) {}

  ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    if (this.previousLink === "/log-in" || this.previousLink === "/auth") {
      window.location.reload();
    }
  }

  showTab(pageName: string) {
    let i: number;
    let tabcontent: any;
    tabcontent = document.getElementsByClassName("info-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(pageName).style.display = "block";
  }
}
